import * as React from 'react'

import type moment from 'moment'

import { observer } from 'mobx-react'

import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type { Shift, ShiftsRow } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import DisabledNightShiftItem from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/DisabledNightShiftItem'
import ShiftLayout from './ShiftLayout'

interface Props {
  shiftsRow: ShiftsRow
  shift: Shift
  date: moment.Moment
  isNightShift: boolean
  previewPlannedBreaks?: PlannedBreak[] | null
  preview: boolean
}

const BaseShift = ({
  shiftsRow,
  shift,
  date,
  isNightShift,
  previewPlannedBreaks = null,
  preview = false,
}: Props) => {
  // Keep these selection hooks here, using this wrapper to be re-rendered
  // but we avoid to re-render the children unless the isSelected prop changes.
  const { isEnabled: isSelectionEnabled, shifts } = useSelectionState()
  const isSelected = !!(shiftsRow.canManage && shifts[shift.referenceKey(date)])
  if (isNightShift) return <DisabledNightShiftItem nightShift={shift} date={date} />

  return (
    <ShiftLayout
      shiftsRow={shiftsRow}
      shift={shift}
      date={date}
      isSelectionEnabled={isSelectionEnabled}
      isSelected={isSelected}
      previewPlannedBreaks={previewPlannedBreaks}
      preview={preview}
    />
  )
}

export default observer(BaseShift)
